import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import "./ContactUsPage.css"; // Import CSS file
import Layout from "../layout/Layout";

const ContactUsPage = () => {
  return (
    <Box>
      <Layout>
        <Box className="contact-container">
          <Box className="contact-content">
            {/* Header Section */}
            <Box className="contact-header">
              <Typography className="contact-header-title">اتصل بنا</Typography>
            </Box>

            {/* Content Section */}
            <Box className="contact-text-container">
              <Typography className="contact-text">
                اذا عندك اي استفسار او ملاحظات او حتى اقتراحات تخلي تجربة يلا
                فلة احلى و امتع احنا هنا عشانك دائما باذن الله.
              </Typography>
              <Typography className="contact-text">
                فلا تتردد بالتواصل مع فريق دعم عملاء يلا فلة.
              </Typography>

              <List className="contact-list">
                <ListItem>
                  <ListItemText
                    primary="الهاتف:"
                    secondary=" +966 56 699 4699"
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="البريد الإلكتروني:"
                    secondary=" sales@yallafalla.com"
                  />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Box>
      </Layout>
    </Box>
  );
};

export default ContactUsPage;
